import { TypographyOptions } from "@mui/material/styles/createTypography";

export const typography: TypographyOptions = {
  fontFamily: "Poppins, Arial, Helvetica, sans-serif",
  h6: {
    fontSize: "1.1rem",
    fontWeight: "500",
    lineHeight: "160%",
    letterSpacing: "0.00938rem",
  },
  h5: {
    color: "var(--text-primary, #4A4A4A)",
    fontSize: "1.2rem",
    fontWeight: "400",
    lineHeight: "133.4%",
  },
  h4: {
    color: "var(--text-primary, #4A4A4A)",
    fontSize: "1.3rem",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "123.5%",
    letterSpacing: "0.01563rem",
  },
};
